var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgDecor = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 10,
  height: 10,
  viewBox: "0 0 10 10",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M0 1C0 0.447715 0.447715 0 1 0C1.55228 0 2 0.447715 2 1C2 1.55228 1.55228 2 1 2C0.447715 2 0 1.55228 0 1Z",
  fill: "#8888A6"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 5C0 4.44772 0.447715 4 1 4C1.55228 4 2 4.44772 2 5C2 5.55228 1.55228 6 1 6C0.447715 6 0 5.55228 0 5Z",
  fill: "#8888A6"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M0 9C0 8.44772 0.447715 8 1 8C1.55228 8 2 8.44772 2 9C2 9.55228 1.55228 10 1 10C0.447715 10 0 9.55228 0 9Z",
  fill: "#8888A6"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  d: "M4 1C4 0.447715 4.44772 0 5 0C5.55228 0 6 0.447715 6 1C6 1.55228 5.55228 2 5 2C4.44772 2 4 1.55228 4 1Z",
  fill: "#8888A6"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "M4 5C4 4.44772 4.44772 4 5 4C5.55228 4 6 4.44772 6 5C6 5.55228 5.55228 6 5 6C4.44772 6 4 5.55228 4 5Z",
  fill: "#8888A6"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  d: "M4 9C4 8.44772 4.44772 8 5 8C5.55228 8 6 8.44772 6 9C6 9.55228 5.55228 10 5 10C4.44772 10 4 9.55228 4 9Z",
  fill: "#8888A6"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  d: "M8 1C8 0.447715 8.44772 0 9 0C9.55228 0 10 0.447715 10 1C10 1.55228 9.55228 2 9 2C8.44772 2 8 1.55228 8 1Z",
  fill: "#8888A6"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  d: "M8 5C8 4.44772 8.44772 4 9 4C9.55228 4 10 4.44772 10 5C10 5.55228 9.55228 6 9 6C8.44772 6 8 5.55228 8 5Z",
  fill: "#8888A6"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  d: "M8 9C8 8.44772 8.44772 8 9 8C9.55228 8 10 8.44772 10 9C10 9.55228 9.55228 10 9 10C8.44772 10 8 9.55228 8 9Z",
  fill: "#8888A6"
})));
export { SvgDecor as ReactComponent };
export default __webpack_public_path__ + "assets/icons/decor.01f435.svg";